import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@zorni/components-lib";

import styles from "./TranslateToggle.module.css";
import useSwitchAllLanguages from "../../../hooks/useSwitchAllLanguages";

export const LANGUAGES = [
  { code: "fr", labelKey: "language.fr", label: "Français" },
  { code: "en", labelKey: "language.en", label: "English" },
];

/** Code court affiché dans l'en-tête : "FR", "EN". */
export const shortCode = (language) =>
  String(language || "fr").split("-")[0].slice(0, 2).toUpperCase();

/**
 * Panneau de choix de langue. La langue active vient d'i18n — l'ancienne
 * version gardait son propre état initialisé à "fr" et le réappliquait à
 * chaque montage, ce qui effaçait le choix de l'utilisateur à chaque
 * remontage de l'en-tête.
 */
const TranslateToggle = ({ onSelect }) => {
  const { t, i18n } = useTranslation();
  const { switchAllLanguages } = useSwitchAllLanguages();

  const active = String(i18n.language || "fr").split("-")[0];

  const handleSelectLanguage = (code) => {
    if (code !== active) switchAllLanguages(code);
    onSelect?.();
  };

  return (
    <div className={styles.panel} role="group" aria-label={t("language.choose", "Choisir la langue")}>
      {LANGUAGES.map((language) => {
        const selected = language.code === active;

        return (
          <button
            key={language.code}
            type="button"
            className={`${styles.item} ${selected ? styles.itemSelected : ""}`}
            onClick={() => handleSelectLanguage(language.code)}
            aria-current={selected ? "true" : undefined}
          >
            <span className={styles.code} aria-hidden="true">
              {shortCode(language.code)}
            </span>
            <span className={styles.label}>{t(language.labelKey, language.label)}</span>
            {selected && (
              <span className={styles.check} aria-hidden="true">
                <Icon name="iconCheck" size="sm" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TranslateToggle;
